import { TabsDocumentsReviewOption } from '@domains/documents-review/store/slices/document-review-slice';

import { WrapperButton } from '@pages/DocumentAuditPage/modules/DocumentTaskDetail/components/DocumentsViewer/styles';
import { useDocumentsHistory } from '../../hooks/useDocumentsHistory';

interface DocumentsHistoryTabProps {
  activeTab: TabsDocumentsReviewOption;
  setActiveTab: (tab: TabsDocumentsReviewOption) => void;
}

export const DocumentsHistoryTab = ({
  activeTab,
  setActiveTab,
}: DocumentsHistoryTabProps) => {
  const { data: history = [] } = useDocumentsHistory();

  if (history.length <= 1) {
    return null;
  }

  return (
    <WrapperButton className="pb-4">
      <button
        className={
          activeTab === TabsDocumentsReviewOption.HISTORY ? 'selected-tab' : ''
        }
        onClick={() => setActiveTab(TabsDocumentsReviewOption.HISTORY)}
        data-testid="documents-history-tab"
      >
        Histórico Tareas
      </button>
    </WrapperButton>
  );
};
